
import { NgModule } from '@angular/core';
import { DatePipe } from '@angular/common';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MatTableModule } from '@angular/material/table';
import { MatPaginatorModule } from '@angular/material/paginator';

import { CalendarChatHistoryComponent } from './calendar-chat-history/calendar-chat-history.component';
import { EstTimePipe } from './history-table/est-time.pipe';
import { HistoryTableComponent } from './history-table/history-table.component';
import { SearchDetailComponent } from './search-detail/search-detail.component';
import { VideoChatComponent } from './video-chat/video-chat.component';
import { IEComponent } from './image-edit/ie.component';
import { ModelGardenComponent } from './model-garden/model-garden.component';
import { RouterModule, Routes } from '@angular/router';
import { SharedModule } from '../shared/shared.module';
import { AudioTranscriptionDashboardComponent } from './audio-transcription-dashboard/audio-transcription-dashboard.component';
import { BotaxVisonComponent } from './botax-vison/botax-vison.component';
import { ChestVisonComponent } from './chest-vison/chest-vison.component';

export const routes: Routes = [
  {
    path: 'calendar',
    component: CalendarChatHistoryComponent
  },
  {
    path: 'search',
    component: HistoryTableComponent
  },
  {
    path: 'botax-vison',
    component: BotaxVisonComponent
  },
  { path: 'breast-vison',
    component: ChestVisonComponent
  },
  {
    path: 'search/:id',
    component: SearchDetailComponent
  },
  {
    path: 'video-chat',
    component: VideoChatComponent
  },
  {
    path: 'photo-lab',
    component: IEComponent
  },
  {
    path: 'model-garden',
    component: ModelGardenComponent
  }
];

@NgModule({
  declarations: [
    CalendarChatHistoryComponent,
    EstTimePipe,
    HistoryTableComponent,
    SearchDetailComponent,
    VideoChatComponent,
    IEComponent,
    AudioTranscriptionDashboardComponent,
    ModelGardenComponent,
    BotaxVisonComponent,
    ChestVisonComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    NgbModule,
    MatTableModule,
    MatPaginatorModule,
    RouterModule.forChild(routes),
    SharedModule
  ],
  providers: [DatePipe]
})
export class TablesModule { }
